import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "./ui/button";

export function BackButton() {
	const navigate = useNavigate();
	return (
		<Button
			variant="ghost"
			size="sm"
			className="hover:bg-transparent h-auto flex gap-1 items-center cursor-pointer has-[>svg]:p-0"
			onClick={() => navigate(-1)}
		>
			<ArrowLeft className="size-4" />
			<span className="text-sm">Back</span>
		</Button>
	);
}
